import { createContext } from "react";

export const DisableShareUrlButtonContext = createContext<boolean | false>(
  false
);
